import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Alert from '../../common/components/alert'
import CurrentProgress from '../../common/components/current-progress'
import Container from '../../common/components/container'
import Button from '../../common/components/button'
import InputField from '../../common/components/input-field'
import QueryString from 'query-string'
import { getQueryString } from '../../common/util'
import checkedOptions from '../../common/options/check-options'
import yesNoOptions from '../../common/options/yes-no-options'
import QuoteNumber from '../../common/components/quote-number'
import { pickBy, identity } from 'lodash'

import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withProductData } from '../../common/modules/product-data';
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    const fields = state.fields
    const productData = state.productData;

    return {
        rules: {
            strataFlag:[
                Validation.enforce.required("Please select a value"),
            ],
            propertyAge:[
                Validation.enforce.required("Please provide the approximate age of the property"),
            ],
            roofConstructionType:[
                Validation.enforce.required("Please provide the roof construction type"),
            ],
            wallConstructionType:[
                Validation.enforce.required("Please provide the wall construction type"),
            ],
            floorConstructionType:[
                Validation.enforce.required("Please provide the floor construction type"),
            ],
            aboveGroundFloor:[
                Validation.enforce.required("Please select a value"),
            ],
            renovations:[
                Validation.enforce.required("Please select a value"),
            ],
            renovationsCost:[
                Validation.enforce.required("Please enter the renovations cost"),
            ],
            occupancyType:[
                Validation.enforce.required("Please select the occupancy type."),
            ],
            incomeGenerating:[
                Validation.enforce.required("Please select a value"),
            ],
            businessActivityDegree:[
                Validation.enforce.required("We cannot determine the business activity type(s) of the property based on the information provided."),
            ],
            businessActivityTypes:[
                Validation.enforce.hasAtLeastOneEntry("Please add at least one type of activity.")
            ],
            oldestResidentDob:[
                Validation.enforce.required("Please provide a valid date in the format DD/MM/YYYY"),
                Validation.enforce.date("Please provide a valid date in the format DD/MM/YYYY")
            ],
            retiredResidents:[
                Validation.enforce.required("Please select a value"),
            ],

            externalDoorsDeadlocks:[],
            externalDoorsSecurityScreen:[],
            externalWindowsKeylocks:[],
            externalWindowsRollerShutter:[],
            externalWindowsSecurityScreen:[],
            otherSecurity24HourMonitoredAlarm:[],
            otherSecurityLocalAlarm:[],
            otherSecurityGatedCommunity:[],
            otherSecurity24HourConcierge:[],
            otherSecurityFixedHomeSafe:[]
        },

        options:{
            strataFlag: yesNoOptions,
            propertyAge: productData.productOptions.BUILDING_AGE,
            wallConstructionType: productData.productOptions.WALL_CONSTRUCTION,
            roofConstructionType: productData.productOptions.ROOF_CONSTRUCTION,
            floorConstructionType: productData.productOptions.FLOOR_CONSTRUCTION,
            aboveGroundFloor: yesNoOptions,
            renovations: yesNoOptions,
            occupancyType: productData.productOptions.OCCUPANCY,
            incomeGenerating: yesNoOptions,
            externalDoorsDeadlocks: checkedOptions,
            externalDoorsSecurityScreen: checkedOptions,
            externalWindowsKeylocks: checkedOptions,
            externalWindowsRollerShutter: checkedOptions,
            externalWindowsSecurityScreen: checkedOptions,
            otherSecurity24HourMonitoredAlarm: checkedOptions,
            otherSecurityLocalAlarm: checkedOptions,
            otherSecurityGatedCommunity: checkedOptions,
            otherSecurity24HourConcierge: checkedOptions,
            otherSecurityFixedHomeSafe: checkedOptions,
            retiredResidents: yesNoOptions,
            businessActivityTypes: productData.productOptions.COMMERCE,
            businessActivityDegree: productData.productOptions.DEGREE_BUSINESS_ACTIVITY
        },

        predicates:{
            renovationsCost: fields.renovations == true,
            businessActivityDegree: fields.incomeGenerating == true,
            businessActivityTypes: fields.incomeGenerating == true
        },

        inferred:{},
        
        transformOut: data => {
            if (data.externalDoorsDeadlocks == null) data.externalDoorsDeadlocks = false;
            if (data.externalDoorsSecurityScreen == null) data.externalDoorsSecurityScreen = false;
            if (data.externalWindowsKeylocks == null) data.externalWindowsKeylocks = false;
            if (data.externalWindowsRollerShutter == null) data.externalWindowsRollerShutter = false;
            if (data.externalWindowsSecurityScreen == null) data.externalWindowsSecurityScreen = false;
            if (data.otherSecurity24HourMonitoredAlarm == null) data.otherSecurity24HourMonitoredAlarm = false;
            if (data.otherSecurityLocalAlarm == null) data.otherSecurityLocalAlarm = false;
            if (data.otherSecurityGatedCommunity == null) data.otherSecurityGatedCommunity = false;
            if (data.otherSecurity24HourConcierge == null) data.otherSecurity24HourConcierge = false;
            if (data.otherSecurityFixedHomeSafe == null) data.otherSecurityFixedHomeSafe = false;
            return data;
        }

    }

}



@withSubmission
@withNavigation
@withValidation
@withProductData
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {


    render() {
        return ( 
            <div className="row">
                <StepTitle>Tell us about the property</StepTitle>	
                <QuoteNumber />
                
                <InputField field="strataFlag"                          label="Is your property an apartment, unit, townhouse, villa or community association lot owners home?" />
                <StepBlock>
                    <Alert show={ this.props.fields.strataFlag === false }>
                        <span style={{color:'#d9534f'}}><i className="fa fa-exclamation-circle"></i> Important! You can only obtain CHU insurance if you live in a unit, apartment, townhouse, villa or any property in a community association.</span>
                    </Alert>
                </StepBlock>
                <InputField field="propertyAge"                         label="What is the approximate age of the property?"  inline  />
                <InputField field="wallConstructionType"                label="What is the construction material of the building's external walls?"  inline/>
                <InputField field="roofConstructionType"                label="What is the construction material of the building's roof?"  inline/>
                <InputField field="floorConstructionType"               label="What is the construction material of the unit's floor?"  inline/>
                <InputField field="aboveGroundFloor"                    label="Is the property above the ground floor?" />
                <InputField field="renovations"                         label="Are any renovations or repairs currently being done to your home?" />
                <InputField field="renovationsCost"                     label="What is the expected cost of the renovations or repairs?" inline  type="Currency" />
                <InputField field="occupancyType"                       label="How is your home occupied?"  inline/>
                <InputField field="incomeGenerating"                    label="Is the property used for any business or income generating activity?"  help="Where you are set-up to conduct any business activity or professional services from your home, but not simply bringing your work home." />
                <InputField field="businessActivityDegree"              label="To what degree is the home used for business activities?" inline/>
                <InputField field="businessActivityTypes"               label="What type of business activity/activities are they?"   multiselect size="col-md-12"/>
                   

                <SubHeader>Tell us about your security</SubHeader>

                <StepBlock><b>What security do you have on all external doors?</b></StepBlock>
                <InputField field="externalDoorsDeadlocks"              label="Deadlocks" />
                <InputField field="externalDoorsSecurityScreen"         label="Door security screens" />

                <StepBlock><b>What security do you have on all external windows?</b></StepBlock>
                <InputField field="externalWindowsKeylocks"             label="Keylocks" />
                <InputField field="externalWindowsRollerShutter"        label="Roller shutter" />
                <InputField field="externalWindowsSecurityScreen"       label="Security screens or bars" />

                <StepBlock><b>What other security do you have?</b></StepBlock>
                <InputField field="otherSecurity24HourMonitoredAlarm"   label="24 hour monitored alarm" />
                <InputField field="otherSecurityLocalAlarm"             label="Local alarm" />
                <InputField field="otherSecurityGatedCommunity"         label="Gated community" />
                <InputField field="otherSecurity24HourConcierge"        label="24 hour concierge" />
                <InputField field="otherSecurityFixedHomeSafe"          label="Fixed home safe" />

                <StepBlock><b>Tell us about the residents?</b></StepBlock>
                <InputField field="oldestResidentDob"                   label="What is the date of birth of the oldest resident?" placeholder="dd/mm/yyyy" inline  type="DateManual"/>
                <InputField field="retiredResidents"                    label="Are any residents retired?"  />


                <Button.Container>
                    <Button.Back route="/step-2" />
                    <Button.Continue onClick={ this.validate.bind(this) } />
                </Button.Container>
            </div>
        )
    }


    
    validate(){
        this.props.actions.validation.validate( this.submit.bind(this) );
    }


    submit(){
        const endpoint = this.props.submission.endpoints.step3
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            formConfig
        ] );
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-4")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/routes/step-3.tsx